import { createContext, useState } from "react";

export const ChangesDetectContext = createContext({
  changeCount: 0,
  increaseChangeCount: () => {},
  resetChangeCount: () => {},
});

export const ChangesDetectProvider = ({ children }) => {
  const [changeCount, setChangeCount] = useState(0);

  const increaseChangeCount = () => setChangeCount(prev => prev + 1);
  const resetChangeCount = () => setChangeCount(0);

  return (
    <ChangesDetectContext.Provider
      value={{ changeCount, increaseChangeCount, resetChangeCount }}>
      {children}
    </ChangesDetectContext.Provider>
  );
};
